import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { AuthService } from "../../base-module/base-service/auth.service";
import { UtilitesService } from "../../base-module/base-service/utilites.service";

@Injectable({ providedIn: 'root' })
export class NotificacaoService {

    qtd_notificacao: any = 0;    
    user:any;
    messagesChannel: any;
    Echo:any;
    notificEcho:any;
    socket: any;

    readonly VAPID_PUBLIC_KEY = environment.publicKey;

    constructor(
        private authService: AuthService,
        private _http: HttpClient,
        public utilitesService: UtilitesService) 
    {
        if(this.authService.isAuthenticated()){
            this.user = JSON.parse(this.authService.getUser() ?? "{}");
            this.getNotificacao();
        } else {
            this.user = {};
        }
    }

    /**
     * Notificação por id
     * @param id ID da Notificação
     */
    getById(id: number): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "notificacao/" + id, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Lista de Notificação
     * @param id ID da Notificação
     */
    getAll(params: any): Observable<any> {

        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if(paramHttp != null && paramHttp != ""){
            env = "?"+paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "notificacao"+env, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Contador de Notificação
     */
    getNotificacao(){
        if(!this.authService.isAuthenticated()){
            return;
        }
        this._http.get(this.utilitesService.urlPrefix + "notificacao/quantidade", { headers: this.authService.getAuthHeaders() }).subscribe({
            next: notificacao => {
                this.setNotificacao(notificacao);
            },
            error: () => {
            }
        });
    }


    /**
     * Delete Notificação
     * @param id ID do Objetivo do Pré-agendamento
     */
    delete(id: number): Observable<any> {
        return this._http.delete(this.utilitesService.urlPrefix + "notificacao/"+id, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Cadastra Notificação
     * @param params Json Objetivo do Pré-agendamento
     */
    create(params: any):Observable<any>{
        return this._http.post(this.utilitesService.urlPrefix + "notificacao", JSON.stringify(params), { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Atualiza Notificação
     * @param params Json Objetivo do Pré-agendamento
     */
    update(id: number, params: any):Observable<any>{
        return this._http.put(this.utilitesService.urlPrefix + "pre-agendamento/objetivo/"+id, JSON.stringify(params), { headers: this.authService.getAuthHeaders() });
    }
    
    notificacao(titulo: any,msg: any){

        const notification = new Notification(titulo, {
            body: msg,
            icon: "assets/images/logos/ico-72.png",            
        });

    }

  	setNotificacao(notificacao: any){
    	window.localStorage.setItem("notificacao", notificacao);
  	}

  	getQtdNotificacao(){
    	return window.localStorage.getItem("notificacao");
    }

}
